module.exports = __webpack_public_path__ + "img/equal.75b88768.svg";